import type { SVGProps } from 'react';
const SvgLocalBar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#local_bar_svg__a)">
      <path
        fill="currentColor"
        d="M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9ZM7.43 7 5.66 5h12.69l-1.78 2H7.43Z"
      />
    </g>
    <defs>
      <clipPath id="local_bar_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocalBar;
